import React from 'react';
import './secTitle.css';

const SecTitle = (props) => {
    return ( 
        <>
        <h2 className='secTitle heading'>
            {props.secTitle}
        </h2>
        </>
     );
}
 
export default SecTitle;